import angular from 'angular'

import { RouteManagerService } from './route-manager.service'

angular
  .module('webregister.services')
  .service('routeManager', RouteManagerService)
